<template>
  <el-dialog
    :title="$t('deleteHousekeepingType.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div class="text-center">
      <p>{{ $t('deleteHousekeepingType.confirmDeleteService') }}</p>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('deleteHousekeepingType.cancel') }}
      </el-button>
      <el-button 
        type="primary" 
        @click="deleteHousekeepingType"
      >
        {{ $t('deleteHousekeepingType.confirmDelete') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteHousekeepingType } from '@/api/admin/housekeepingTypeApi'

export default {
  name: 'DeleteHousekeepingType',
  data() {
    return {
      dialogVisible: false,
      deleteHousekeepingTypeInfo: {}
    }
  },
  methods: {
    open(params) {
      this.deleteHousekeepingTypeInfo = { ...params }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.deleteHousekeepingTypeInfo = {}
    },
    async deleteHousekeepingType() {
      try {
        await deleteHousekeepingType(this.deleteHousekeepingTypeInfo)
        this.$message.success(this.$t('deleteHousekeepingType.deleteSuccess'))
        this.closeDialog()
        this.$emit('success')
      } catch (error) {
        console.error('删除家政类型失败:', error)
        this.$message.error(error.message || this.$t('deleteHousekeepingType.deleteFailed'))
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
  font-size: 16px;
  margin: 20px 0;
}
</style>